export const disabledButton = '!bg-mediumGray !border-mediumGray !hover:text-white !pointer-events-none'